(function () {
  var fine = !!window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var me = document.currentScript, d = (me && me.dataset) || {};
  var TX = {
    search: d.search || 'Search country or currency',
    gulf: d.gulf || 'Gulf',
    all: d.all || 'All countries',
    none: d.none || 'No country matches',
    label: d.label || 'Country and currency',
    close: d.close || 'Close'
  };
  var GULF = ['BH', 'SA', 'AE', 'KW', 'QA', 'OM'];
  var ALIAS = { uk: 'GB', britain: 'GB', england: 'GB', scotland: 'GB', wales: 'GB', usa: 'US', america: 'US', uae: 'AE',
    emirates: 'AE', dubai: 'AE', 'abu dhabi': 'AE', ksa: 'SA', riyadh: 'SA', jeddah: 'SA', holland: 'NL', korea: 'KR' };
  var CUR = /\s+\u00b7\s+([A-Z]{3})\s*$/;
  var uid = 0, current = null;

  function fold(s) { return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
  function nameOf(o) { return o.textContent.replace(CUR, '').trim(); }
  function currencies() {
    var m = {};
    document.querySelectorAll('select[name="country_code"] option').forEach(function (o) {
      var c = CUR.exec(o.textContent);
      if (c && o.value) m[o.value] = c[1];
    });
    return m;
  }

  function Picker(sel) {
    var form = sel.form;
    if (!form || sel.getAttribute('data-p8-cp')) return;
    sel.setAttribute('data-p8-cp', '1');
    var id = 'p8cp' + (++uid), bar = !!sel.closest('.p8-utility');

    var wrap = document.createElement('div');
    wrap.className = 'p8-cp' + (bar ? ' p8-cp--bar' : '');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = id + 'b';
    btn.className = 'p8-cp__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + 'p');
    var lbl = sel.labels && sel.labels[0];
    if (lbl) {
      if (!lbl.id) lbl.id = id + 'l';
      lbl.htmlFor = btn.id;
    } else {
      lbl = document.createElement('span');
      lbl.className = 'p8-cp__vh';
      lbl.id = id + 'l';
      lbl.textContent = sel.getAttribute('aria-label') || TX.label;
      btn.appendChild(lbl);
    }
    var val = document.createElement('span');
    val.className = 'p8-cp__val';
    val.id = id + 'v';
    btn.appendChild(val);
    btn.insertAdjacentHTML('beforeend', '<svg class="p8-cp__chev" aria-hidden="true" focusable="false" viewBox="0 0 10 6" width="10" height="6"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>');
    btn.setAttribute('aria-labelledby', lbl.id + ' ' + val.id);

    var panel = document.createElement('div');
    panel.className = 'p8-cp__panel';
    panel.id = id + 'p';
    panel.hidden = true;
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'p8-cp__search';
    input.placeholder = TX.search;
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-label', TX.search);
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    var list = document.createElement('div');
    list.className = 'p8-cp__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-labelledby', lbl.id);
    var none = document.createElement('p');
    none.className = 'p8-cp__none';
    none.setAttribute('aria-live', 'polite');
    var head = document.createElement('div');
    head.className = 'p8-cp__head';
    var ttl = document.createElement('span');
    ttl.className = 'p8-cp__title';
    ttl.textContent = lbl.textContent.trim();
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'p8-cp__close';
    x.setAttribute('aria-label', TX.close);
    x.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 14 14" width="14" height="14"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    head.appendChild(ttl);
    head.appendChild(x);
    panel.appendChild(head);
    panel.appendChild(input);
    panel.appendChild(list);
    panel.appendChild(none);

    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(btn);
    wrap.appendChild(sel);
    sel.hidden = true;
    sel.tabIndex = -1;
    document.body.appendChild(panel);

    var opts = [], active = -1, sheet = false, lock = '';
    function selected() { return sel.options[sel.selectedIndex]; }
    function show() { var o = selected(); val.textContent = o ? o.textContent.trim() : ''; }

    function item(it) {
      var el = document.createElement('div');
      el.className = 'p8-cp__opt';
      el.id = id + '-' + it.v;
      el.setAttribute('role', 'option');
      el.setAttribute('data-v', it.v);
      el.setAttribute('aria-selected', it.v === sel.value ? 'true' : 'false');
      var t = document.createElement('span'); t.className = 'p8-cp__tick'; t.setAttribute('aria-hidden', 'true');
      var n = document.createElement('span'); n.className = 'p8-cp__n'; n.textContent = it.n;
      var c = document.createElement('span'); c.className = 'p8-cp__c'; c.textContent = it.c;
      el.appendChild(t); el.appendChild(n); el.appendChild(c);
      opts.push(el);
      return el;
    }
    function group(name, items) {
      if (!items.length) return;
      var g = document.createElement('div');
      g.setAttribute('role', 'group');
      var h = document.createElement('div');
      h.className = 'p8-cp__group';
      h.id = id + '-g' + list.children.length;
      h.setAttribute('role', 'presentation');
      h.textContent = name;
      g.setAttribute('aria-labelledby', h.id);
      g.appendChild(h);
      items.forEach(function (it) { g.appendChild(item(it)); });
      list.appendChild(g);
    }
    function build(q) {
      var cur = currencies(), f = fold(q || ''), all = [];
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (o.value) all.push({ v: o.value, n: nameOf(o), c: cur[o.value] || '', k: fold(nameOf(o)) });
      }
      list.textContent = '';
      opts = [];
      active = -1;
      if (!f) {
        var gulf = GULF.map(function (c) { return all.filter(function (it) { return it.v === c; })[0]; }).filter(Boolean);
        group(TX.gulf, gulf);
        group(TX.all, all.filter(function (it) { return GULF.indexOf(it.v) < 0; }));
      } else {
        var al = Object.keys(ALIAS).filter(function (a) { return a === f || (f.length > 2 && a.indexOf(f) === 0); }).map(function (a) { return ALIAS[a]; });
        var rank = function (it) {
          if (it.v.toLowerCase() === f || al.indexOf(it.v) > -1) return 0;
          if (it.k.indexOf(f) === 0 || it.c.toLowerCase() === f) return 1;
          if (it.k.indexOf(' ' + f) > -1) return 2;
          if (it.k.indexOf(f) > -1) return 3;
          if (f.length > 1 && it.c.toLowerCase().indexOf(f) === 0) return 4;
          return 9;
        };
        all.map(function (it, i) { return { it: it, r: rank(it), i: i }; })
          .filter(function (x) { return x.r < 9; })
          .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
          .forEach(function (x) { list.appendChild(item(x.it)); });
      }
      none.textContent = opts.length ? '' : TX.none;
      none.hidden = !!opts.length;
    }
    function setActive(i, how) {
      if (opts[active]) opts[active].classList.remove('is-active');
      active = opts.length ? Math.max(0, Math.min(i, opts.length - 1)) : -1;
      var el = opts[active];
      if (!el) { input.removeAttribute('aria-activedescendant'); return; }
      el.classList.add('is-active');
      input.setAttribute('aria-activedescendant', el.id);
      if (how === 'center') list.scrollTop = el.offsetTop - list.offsetTop - (list.clientHeight - el.offsetHeight) / 2;
      else if (how) el.scrollIntoView({ block: 'nearest' });
    }
    function place() {
      if (sheet) return;
      var r = btn.getBoundingClientRect(), vw = document.documentElement.clientWidth, vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) { close(false); return; }
      var w = Math.min(340, vw - 32), rtl = getComputedStyle(btn).direction === 'rtl';
      var left = rtl ? r.right - w : r.left;
      if (left + w > vw - 16) left = r.right - w;
      left = Math.max(16, Math.min(left, vw - 16 - w));
      var below = vh - r.bottom - 24, above = r.top - 24;
      var up = below < 320 && above > below;
      panel.style.width = w + 'px';
      panel.style.left = left + 'px';
      panel.style.maxHeight = Math.max(160, Math.min(440, up ? above : below)) + 'px';
      if (up) { panel.style.top = 'auto'; panel.style.bottom = (vh - r.top + 8) + 'px'; }
      else { panel.style.bottom = 'auto'; panel.style.top = (r.bottom + 8) + 'px'; }
    }
    function onScroll(e) { if (e.target === document || !panel.contains(e.target)) place(); }
    function outside(e) { if (!panel.contains(e.target) && !btn.contains(e.target)) close(false); }
    function open() {
      if (current && current !== api) current.close(false);
      input.value = '';
      build('');
      sheet = !fine && document.documentElement.clientWidth < 768;
      panel.classList.toggle('p8-cp__panel--sheet', sheet);
      if (sheet) {
        ['left', 'top', 'bottom', 'width', 'maxHeight'].forEach(function (k) { panel.style[k] = ''; });
        lock = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      panel.hidden = false;
      place();
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      current = api;
      var i = -1;
      opts.forEach(function (o, n) { if (o.getAttribute('data-v') === sel.value) i = n; });
      setActive(i < 0 ? 0 : i, 'center');
      (sheet ? x : input).focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
      window.addEventListener('resize', place);
      window.addEventListener('scroll', onScroll, true);
    }
    function close(focus) {
      if (panel.hidden) return;
      panel.hidden = true;
      if (sheet) document.documentElement.style.overflow = lock;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      if (current === api) current = null;
      document.removeEventListener('pointerdown', outside, true);
      window.removeEventListener('resize', place);
      window.removeEventListener('scroll', onScroll, true);
      if (focus) btn.focus();
    }
    function choose(v) {
      close(true);
      if (!v || v === sel.value) return;
      sel.value = v;
      show();
      wrap.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      if (typeof sel.onchange !== 'function') form.submit();
    }

    x.addEventListener('click', function () { close(true); });
    btn.addEventListener('click', function () { if (panel.hidden) open(); else close(true); });
    btn.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && panel.hidden) { e.preventDefault(); open(); }
    });
    input.addEventListener('input', function () { build(input.value); setActive(0); list.scrollTop = 0; });
    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown') { e.preventDefault(); setActive(active + 1, true); }
      else if (k === 'ArrowUp') { e.preventDefault(); setActive(active - 1, true); }
      else if (k === 'PageDown') { e.preventDefault(); setActive(active + 8, true); }
      else if (k === 'PageUp') { e.preventDefault(); setActive(active - 8, true); }
      else if (k === 'Enter') { e.preventDefault(); if (opts[active]) choose(opts[active].getAttribute('data-v')); }
      else if (k === 'Escape') { e.preventDefault(); close(true); }
      else if (k === 'Tab') close(true);
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('mousemove', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o && opts.indexOf(o) !== active) setActive(opts.indexOf(o));
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) choose(o.getAttribute('data-v'));
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      for (var i = 0; i < sel.options.length; i++) if (sel.options[i].defaultSelected) sel.selectedIndex = i;
      wrap.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      show();
    });

    var api = { close: close };
    show();
  }

  document.querySelectorAll('form select[name="country_code"]').forEach(Picker);
})();
